import React from 'react'

import { cn } from '@/legacy-src/lib/utils'
import { rebrandColors } from '@/legacy-src/utilities/colors'

interface BottomArrowProps {
  isBusinessPage?: boolean
  className?: string
}

const BottomArrow = ({ isBusinessPage, className }: BottomArrowProps) => {
  const color =
    isBusinessPage === undefined ? undefined : isBusinessPage ? rebrandColors.blue[500] : rebrandColors.sand[500]

  return (
    <svg
      aria-hidden="true"
      width="98"
      height="30"
      viewBox="0 0 98 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('absolute bottom-[-30px] left-0 right-0 z-20 m-auto', className)}
      style={{ color }}
    >
      <g clipPath="url(#clip0_17308_52960)">
        <path
          d="M52.4389 25.9025L50 30L46.9183 25.3775C36.3487 9.52304 18.5547 0 -0.5 0V-21H98V0C79.309 0 61.9988 9.84124 52.4389 25.9025Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17308_52960">
          <rect width="98" height="30" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BottomArrow
